import axios from 'axios';

export const getLastVersion = async () => {
  const yamlFiles = [
    'https://release.quartermaster.io/releases/latest/latest-linux.yml',
    'https://release.quartermaster.io/releases/latest/latest-mac.yml',
    'https://release.quartermaster.io/releases/latest/latest-windows.yml',
  ];

  // Try fetching from each YAML file until one succeeds
  for (const url of yamlFiles) {
    try {
      const response = await axios.get(url, { responseType: 'text' });
      const lines = response.data.split('\n');
      for (const line of lines) {
        if (line.startsWith('version: ')) {
          return line.replace('version: ', '').trim();
        }
      }
    } catch (error) {
      console.warn(`Failed to fetch version from ${url}:`, error.message);
      continue;
    }
  }
  
  throw new Error('Version not found in any YAML file');
};

export const fallbackHubStats = [
  { label: 'Total Agents', value: '1,250+', icon: '🤖', color: '#10b981' },
  { label: 'API Programs', value: '500+', icon: '🔗', color: '#6366f1' },
  { label: 'Active Users', value: '10K+', icon: '👥', color: '#f59e0b' },
  { label: 'Daily Runs', value: '50K+', icon: '⚡', color: '#8b5cf6' },
];

const hubStatsColors = {
  Agents: '#10b981',
  Programs: '#6366f1',
  Users: '#f59e0b',
  Flows: '#8b5cf6',
};
const hubStatsIcons = {
  Agents: '🤖',
  Programs: '🔗',
  Users: '👥',
  Flows: '⚡',
};

export const axiosBase = axios.create({
  // baseURL: 'http://localhost:8000/api/',
  baseURL: 'https://api.prod.quartermaster.io/api/',
  timeout: 5000,
});

export const loadStatsApi = async () => {
  return Promise.resolve()
    .then(() => axiosBase('/core/app-stats/'))
    .then((response) => {
      const newHubStats = ['Agents', 'Programs', 'Users', 'Flows'].map(
        (label) => {
          let value = '';
          if (label === 'Agents') value = response.data['n_agents'];
          else if (label === 'Programs') value = response.data['n_programs'];
          else if (label === 'Users') value = response.data['n_users'];
          else if (label === 'Flows') value = response.data['n_flows'];

          return {
            label,
            value,
            icon: hubStatsIcons[label] || '',
            color: hubStatsColors[label] || '#000000',
          };
        }
      );
      return newHubStats;
    });
};

export const loadAgentsApi = async (search, offset = 0, limit = 9) => {
  return Promise.resolve()
    .then(() =>
      axiosBase('assistants/search/', {
        params: { name: search || '', limit, offset },
      })
    )
    .then((response) => {
      return response.data;
    });
};

export const loadProgramsApi = async (search, offset = 0, limit = 9) => {
  return Promise.resolve()
    .then(() =>
      axiosBase('programs/search/', {
        params: { title: search || '', limit, offset },
      })
    )
    .then((response) => {
      return response.data;
    });
};

export const loadHotAgentsApi = async () => {
  return Promise.resolve()

    .then(() => axiosBase('assistants/hot-agents/'))
    .then((response) => {
      return response.data;
    });
};

export const loadPricesApi = async () => {
  return Promise.resolve()
    .then(() => axiosBase('providers/models/'))
    .then((response) => response.data);
};
